import { render, staticRenderFns } from "./InsuFaq.vue?vue&type=template&id=22926974&scoped=true&"
import script from "./InsuFaq.vue?vue&type=script&lang=js&"
export * from "./InsuFaq.vue?vue&type=script&lang=js&"
import style0 from "./InsuFaq.vue?vue&type=style&index=0&id=22926974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22926974",
  null
  
)

export default component.exports